import React, { useState, useEffect } from "react";
import api from "../../../api/api";
import AdminPanel from "../panel/AdminPanel";
import "../styles/ViewHallTicket.css";

const ViewHallTicket = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [activeTicketIndex, setActiveTicketIndex] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch tickets dynamically from backend
  useEffect(() => {
    api.get("/api/hall-tickets")
      .then((res) => setTickets(res.data || []))
      .catch((err) => console.error("Error fetching tickets:", err))
      .finally(() => setLoading(false));
  }, []);

  // Reply and update admin comment
  const handleReply = async (index) => {
    const ticket = tickets[index];

    try {
      await api.put(`/api/hall-tickets/${ticket.id}/reply`, {
        admin_comment: ticket.adminComment,
      });

      const updatedTickets = [...tickets];
      updatedTickets[index].status = "Replied";
      setTickets(updatedTickets);
      setActiveTicketIndex(null);
    } catch (err) {
      console.error("Error replying to ticket:", err);
    }
  };

  if (loading) return <p>Loading tickets...</p>;

  return (
    <>
      <AdminPanel onToggle={setIsSidebarCollapsed} />
      <div className={`page-container ${isSidebarCollapsed ? "collapsed" : ""}`}>
        <h1>Manage Hall Tickets</h1>

        <div className="tickets-container">
          {tickets.map((ticket, index) => (
            <div key={ticket.id} className="ticket-card">
              <h3>{ticket.student_name}</h3>
              <button
                className="see-ticket-btn"
                onClick={() => setActiveTicketIndex(index)}
              >
                See Ticket
              </button>
            </div>
          ))}
        </div>

        {/* Ticket Modal */}
        {activeTicketIndex !== null && (
          <div
            className="notice-modal-overlay"
            onClick={(e) => {
              if (e.target.classList.contains("notice-modal-overlay")) {
                setActiveTicketIndex(null);
              }
            }}
          >
            <div className="notice-modal">
              <h2>
                {tickets[activeTicketIndex].student_name} -{" "}
                {tickets[activeTicketIndex].exam_name}
              </h2>

              <div className="ticket-info-table">
                <table>
                  <tbody>
                    <tr>
                      <td>Student</td>
                      <td>{tickets[activeTicketIndex].student_name}</td>
                    </tr>
                    <tr>
                      <td>Exam</td>
                      <td>{tickets[activeTicketIndex].exam_name}</td>
                    </tr>
                    <tr>
                      <td>Date</td>
                      <td>{tickets[activeTicketIndex].exam_date}</td>
                    </tr>
                    <tr>
                      <td>Status</td>
                      <td>{tickets[activeTicketIndex].status}</td>
                    </tr>
                    <tr>
                      <td>Parent Message</td>
                      <td>{tickets[activeTicketIndex].parent_message}</td>
                    </tr>
                    {tickets[activeTicketIndex].attachment && (
                      <tr>
                        <td>Attachment</td>
                        <td>
                          <img
                            src={`${api.defaults.baseURL}/uploads/${tickets[activeTicketIndex].attachment}`}
                            alt="Attachment"
                            onClick={() =>
                              setPreviewImage(
                                `${api.defaults.baseURL}/uploads/${tickets[activeTicketIndex].attachment}`
                              )
                            }
                            style={{
                              cursor: "pointer",
                              maxWidth: "150px",
                              borderRadius: "8px",
                            }}
                          />
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              <label>
                Admin Comment:
                <textarea
                  placeholder="Write your comment..."
                  value={tickets[activeTicketIndex].adminComment || ""}
                  onChange={(e) => {
                    const updatedTickets = [...tickets];
                    updatedTickets[activeTicketIndex].adminComment = e.target.value;
                    setTickets(updatedTickets);
                  }}
                />
              </label>

              <div className="notice-modal-actions">
                <button onClick={() => handleReply(activeTicketIndex)}>Reply</button>
                <button onClick={() => setActiveTicketIndex(null)}>Close</button>
              </div>

              {tickets[activeTicketIndex].adminComment && (
                <div className="admin-comment">
                  <strong>Admin Comment:</strong>
                  <p>{tickets[activeTicketIndex].adminComment}</p>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Image Preview Overlay */}
        {previewImage && (
          <div
            className="image-preview-overlay"
            onClick={() => setPreviewImage(null)}
          >
            <div
              className="image-preview-content"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="close-modal"
                onClick={() => setPreviewImage(null)}
              >
                ✖
              </button>
              <img src={previewImage} alt="Preview" />
              <a href={previewImage} download className="download-btn">
                Download
              </a>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ViewHallTicket;
